import React from 'react';
import RealEstateResult from './RealEstateResult';
const ComplexResult = ({ hit }) => {
    var _a, _b;
    const complex = hit._source.fields;
    const content = [(_a = complex.city) === null || _a === void 0 ? void 0 : _a.toUpperCase(), (_b = complex.quarter) === null || _b === void 0 ? void 0 : _b.toUpperCase()].filter(Boolean).join(' - ');
    return React.createElement(RealEstateResult, { hit: hit, imageUrl: complex.list_image, title: complex.name, content: content });
};
export default ComplexResult;
